// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"61":"b49ea6684ddb44ed","104":"81fd8bb182af9896","988":"1d30f6fb379aaf13"}[chunkId] + ".js";
};